module.exports = __webpack_public_path__ + "img/003.3b898f42.jpg";